import React, { Component } from "react";
import { X, XLg } from "react-bootstrap-icons";

import type Task from "../../models/Task";
import type SubTaskCollection from "../../models/SubTaskCollection";
import type SubTask from "../../models/SubTask";
import SubtaskForm from "../../../../components/forms/subtask-form/SubtaskForm";
import SubtaskInput from "../../../../components/forms/subtask-input/SubtaskInput";

type Props = {
  userHasOwnerPrivileges: boolean,
  task: Task,
  subTasks: SubTaskCollection,
  isOwner: boolean,
  accountExpired: boolean,
  onRequestToggleTaskCompleteness: () => void,
  onRequestToggleSubTaskCompleteness: (subTask: SubTask) => void,
  createSubTask: (params: CreateSubTaskObject) => Promise<void>,
  loadSubTasks: (taskId: string) => Promise<void>,
  openDeleteTaskModal: (task: Task) => void,
  openDeleteSubTaskModal: (subTask: SubTask) => void,
};

export default class TaskView extends Component {
  props: Props;
  state: State = {
    isOpen: false,
  };
  loadTasksPromise: ?Promise<void>;
  createTaskPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadSubTasks(this.props.task.id);
  }

  render() {
    return (
      <div className="task-row">
        <div
          className="task-category pointer"
          onClick={() => this.setState({ isOpen: !this.state.isOpen })}
        >
          <div className="task-category-title">{this.props.task.details}</div>
          <div className="task-category-delete">
            {!!this.props.isOwner &&
              !this.props.accountExpired &&
              this.renderEditButtons(this.props.task)}
          </div>
        </div>
        {!!this.state.isOpen && (
          <div className="subtasks-container deuppercase-children">
            {this.props.isOwner && !this.props.accountExpired
              ? this.renderSubTaskForm()
              : null}
            {this.renderSubTasks()}
          </div>
        )}
      </div>
    );
  }

  renderSubTasks() {
    const filteredTasks = this.props.subTasks.filterByParentTask(
      this.props.task.id
    );
    const subTasks = filteredTasks.toArray();
    return (
      subTasks
        // If one is completed move it toward the bottom, but don't change the
        // order if they're both the same.
        .sort((a, b) =>
          a.isComplete
            ? !b.isComplete
              ? 1
              : 0
            : !a.isComplete
            ? b.isComplete
              ? -1
              : 0
            : 0
        )
        .map(this.renderSubTask)
    );
  }

  renderSubTask = (subTask: SubTask) => {
    return (
      <div key={subTask.id} className="subtask">
        <SubtaskInput
          isOwner={this.props.isOwner}
          accountExpired={this.props.accountExpired}
          subTask={subTask}
          onRequestToggleSubTaskCompleteness={() => {
            this.props.onRequestToggleSubTaskCompleteness(subTask);
          }}
        />
        {this.props.isOwner && !this.props.accountExpired
          ? this.renderEditSubtaskButton(subTask)
          : null}
      </div>
    );
  };

  renderSubTaskForm() {
    return (
      <SubtaskForm
        task={this.props.task}
        createSubTask={this.props.createSubTask}
      />
    );
  }

  renderEditButtons = (task) => {
    return (
      <button
        style={{ color: "black" }}
        className="strip-btn-styles icon-button"
        type="button"
        onClick={() => {
          this.props.openDeleteTaskModal(task);
        }}
      >
        <XLg size="18" />
      </button>
    );
  };

  renderEditSubtaskButton = (subTask) => {
    return (
      <button
        style={{ color: "black" }}
        className="strip-btn-styles icon-button"
        type="button"
        onClick={() => {
          this.props.openDeleteSubTaskModal(subTask);
        }}
      >
        <X size="18" />
      </button>
    );
  };
}



// WEBPACK FOOTER //
// ./src/views/user/tasklist/task-view/TaskView.js